import MediaflowService from '@/services/MediaflowService'

/**
 * Creates a flow (scene or break) and its sources in one step. The API has no
 * single call for this, so when a source is refused the new flow is deleted
 * again: a failed create leaves nothing behind.
 *
 * `payloads` are listed top layer first, like `flow.media`. The server puts
 * each new source in front (`$position: 0`), so they are sent bottom first.
 * Pass a function to build them once the flow exists (image uploads need its id).
 */
export async function createFlowWithMedia(mediaflowId, name, extra = {}, payloads = []) {
	const created = await MediaflowService.createFlow(mediaflowId, name, extra)
	try {
		const list = typeof payloads === 'function' ? await payloads(created) : payloads
		for (const payload of [...(list || [])].reverse()) {
			// eslint-disable-next-line no-await-in-loop
			await MediaflowService.createFlowMedia(mediaflowId, created._id, payload)
		}
	} catch (err) {
		try {
			await MediaflowService.deleteFlow(mediaflowId, created._id)
		} catch (cleanupErr) {
			console.error('Failed to remove the half-created flow', cleanupErr)
		}
		throw err
	}
	return created
}
